module.exports = "<p>\n  management-timeoff-user-dialog works!\n</p>\n"